import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const fmt2 = (n) => Number(n ?? 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmt4 = (n) => Number(n ?? 0).toLocaleString("tr-TR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });

function Row({ label, value, mono, gold }) {
  return (
    <div className="flex justify-between items-baseline py-3 border-b border-white/5">
      <span className="label-caps">{label}</span>
      <span className={`${mono ? "font-mono tabular-nums" : ""} ${gold ? "text-lg" : ""}`} style={gold ? {color:"var(--gold)"} : {}}>
        {value}
      </span>
    </div>
  );
}

export default function ZReport() {
  const [z, setZ] = useState(null);
  useEffect(() => {
    api.get("/reports/z").then((r) => setZ(r.data));
    const iv = setInterval(() => api.get("/reports/z").then((r) => setZ(r.data)), 15000);
    return () => clearInterval(iv);
  }, []);

  if (!z) return <div data-testid="zreport-page">Yükleniyor…</div>;

  return (
    <div className="space-y-8" data-testid="zreport-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="label-caps">Uzaktan Denetim · {z.date}</div>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-2 font-light">Z Raporu</h1>
        </div>
        <button onClick={()=>window.print()} className="btn-gold" data-testid="zreport-print">Yazdır</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="card-flat p-6" data-testid="z-sale">
          <div className="label-caps">Toplam Satış</div>
          <div className="font-mono text-3xl mt-3 tabular-nums" style={{color:"var(--gold)"}}>{fmt2(z.sale_total)} ₺</div>
        </div>
        <div className="card-flat p-6" data-testid="z-cash">
          <div className="label-caps">Nakit</div>
          <div className="font-mono text-3xl mt-3 tabular-nums">{fmt2(z.cash_total)} ₺</div>
        </div>
        <div className="card-flat p-6" data-testid="z-card">
          <div className="label-caps">Kredi Kartı</div>
          <div className="font-mono text-3xl mt-3 tabular-nums">{fmt2(z.card_total)} ₺</div>
        </div>
        <div className="card-flat p-6" data-testid="z-scrap">
          <div className="label-caps">Hurda Alımı</div>
          <div className="font-mono text-3xl mt-3 tabular-nums">{fmt2(z.scrap_total)} ₺</div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card-flat p-8">
          <div className="label-caps mb-2">Özet</div>
          <div className="font-display text-2xl mb-6">Günlük Denetim</div>
          <Row label="Toplam İşlem" value={z.transaction_count} mono />
          <Row label="Net Has Bakiye" value={`${fmt4(z.net_gold_gram)} gr`} mono gold />
          <Row label="Toplam Ciro" value={`${fmt2(z.sale_total + z.scrap_total)} ₺`} mono gold />
        </div>

        <div className="card-flat p-8" data-testid="z-staff">
          <div className="label-caps mb-2">Personel Performansı</div>
          <div className="font-display text-2xl mb-6">Bugün</div>
          {z.staff_performance.length === 0 && <div className="text-sm text-neutral-500">Kayıt yok</div>}
          {z.staff_performance.map((s) => (
            <div key={s.user_id} className="flex justify-between items-center py-3 border-b border-white/5">
              <div>
                <div className="text-sm">{s.name}</div>
                <div className="label-caps mt-1">{s.count} işlem</div>
              </div>
              <div className="font-mono tabular-nums" style={{color:"var(--gold)"}}>{fmt2(s.total)} ₺</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
